import { animate, style, transition, trigger } from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'hour4u-admin-rtsp-preview',
  templateUrl: './rtsp-preview.component.html',
  styleUrls: ['./rtsp-preview.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }), // Start hidden
        animate('500ms ease-in-out', style({ opacity: 1 })) // Fade in
      ]),
      transition(':leave', [
        animate('500ms ease-in-out', style({ opacity: 0 })) // Fade out
      ])
    ])
  ]
})
export class RtspPreviewComponent implements OnInit {
  rtspUrl: string = '';
  question: string = '';
  backendUrl: string = 'http://64.227.155.230:8000';
  projectFormGroup: any;
  agentThirdForm: any;
  profile = this.appService.getCurrentAccount();
  projectsList: any = [];
  projectPageIndex = 1;
  projectPageSize = 1000;
  projectResultsLength = 0;
  projectPagination: any = null;
  fetchedKeywordsList: any[] = []; // Store fetched keywords for selected stream

  detectionResults: any = {}; // Store detection results
  detectionInterval: any; // Polling interval
  isConnected = false; // Controls when to show alert component

  callActions: any[] = [
    // {
    //   id: 1,
    //   value: 'Send email'
    // },
    {
      id: 2,
      value: 'Schedule Meeting'
    },
    // {
    //   id: 3,
    //   value: 'Transfer call'
    // },
    // {
    //   id: 4,
    //   value: 'Send SMS'
    // },
    // {
    //   id: 5,
    //   value: 'Take message and send email'
    // },
    {
      id: 6,
      value: 'Update Status'
    },
  ];
  appearanceList: any[] = [
    {
      id: 1,
      value: 'red',
      label: 'Red'
    },
    {
      id: 2,
      value: 'yellow',
      label: 'Yellow'
    },
    {
      id: 3,
      value: 'blue',
      label: 'Blue'
    },
    {
      id: 4,
      value: 'pink',
      label: 'Pink'
    },
  ];
  isLoading: boolean;
  streamsList: any[];
  selectedStreamId: any;
  selectedStreamUrl: string;
  waitingForStream: boolean;

  constructor(
    private _formBuilder: FormBuilder,
    public jobService: JobService,
    public appService: AppService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.projectFormGroup = this._formBuilder.group({
      projectId: ['', Validators.required],
      streamUrl: [
        '',
        [
          Validators.required,
          Validators.pattern('^rtsp:\\/\\/.+') // Only allow rtsp:// URLs
        ]
      ],
      id: [''],
      projectName: [''],
      description: [''],
      userPrompt: [''],
    });

    this.agentThirdForm = this._formBuilder.group({
      outcomes: this._formBuilder.array([
        this.getOutComesArray()
      ]),
    });

    this.getAllProjects();
    //this.addMoreOutcomes();

    // ✅ Listen for project selection and load streams
    this.projectFormGroup.get('projectId').valueChanges.subscribe(projectId => {
      if (projectId) {
        console.log('Project selected:', projectId);
        this.loadStreamsForProject(projectId);
      } else {
        this.streamsList = []; // Clear streams if no project is selected
      }
    });

    // Subscribe to detection results from job service
    this.jobService.detectionResults$.subscribe(res => {
      this.detectionResults = res;
    });
  }

  async startStream() {
    this.waitingForStream = true;
    this.rtspUrl = this.selectedStreamUrl; // Get the RTSP URL from the selected stream

    if (!this.rtspUrl) {
      alert('Please select a valid stream.');
      return;
    }

    let sessionId: string | null = null;

    try {
      console.log('Sending RTSP URL to backend:', this.rtspUrl);

      // Step 1: Send RTSP URL to /start-stream
      const offerResponse = await fetch(`${this.backendUrl}/start-stream`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url: this.rtspUrl }),
      });

      if (!offerResponse.ok) {
        throw new Error('Failed to fetch SDP offer from backend');
      }

      const offer = await offerResponse.json();
      sessionId = offer.session_id; // Save session_id from the response
      console.log('Received SDP offer and session_id:', offer);

      // Step 2: Create WebRTC PeerConnection
      const pc = new RTCPeerConnection();
      console.log('Created PeerConnection');

      // Handle ontrack event
      pc.ontrack = (event) => {
        console.log('Track received:', event.streams[0]);
        const videoElement = document.getElementById('videoElement') as HTMLVideoElement;
        if (event.streams[0]) {
          videoElement.srcObject = event.streams[0];
          console.log('Video stream attached to video element.');
          videoElement.play().catch((err) => {
            console.error('Video playback error:', err);
          });
        } else {
          console.error('No stream received in ontrack event.');
        }
      };

      // Debug ICE candidates
      pc.oniceconnectionstatechange = () => {
        console.log('ICE Connection State:', pc.iceConnectionState);
      };

      pc.onicecandidate = (event) => {
        if (event.candidate) {
          console.log('ICE Candidate:', event.candidate);
        } else {
          console.log('All ICE leads have been sent.');
        }
      };

      // Step 3: Set the remote description using SDP offer
      await pc.setRemoteDescription(new RTCSessionDescription(offer));
      console.log('Set remote description');

      // Step 4: Create an SDP answer
      const answer = await pc.createAnswer();
      console.log('Created SDP answer');

      await pc.setLocalDescription(answer);
      console.log('Set local description');

      // Step 5: Send SDP answer back to the backend
      console.log('Sending SDP answer back to backend...');
      const answerResponse = await fetch(`${this.backendUrl}/answer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sdp: pc.localDescription ? pc.localDescription.sdp : null,
          type: pc.localDescription ? pc.localDescription.type : null,
          session_id: sessionId, // Include session_id in the request
        }),
      });

      if (!answerResponse.ok) {
        throw new Error('Failed to send SDP answer to backend');
      }

      console.log('WebRTC connection established!');
      this.waitingForStream = false;
    } catch (error) {
      console.error('Error during streaming:', error.message);
      this.waitingForStream = false;
    }
  }

  addMoreOutcomes() {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.push(this.getOutComesArray());
  }

  getOutComesArray() {
    let f = this._formBuilder.group({
      outcome_name: ['', [Validators.required]],
      outcome_appearance: ['', [Validators.required]],
      outcome_description: [''],
      conditions: this._formBuilder.array([this.getConditionsArray()]),
      callActions: this._formBuilder.array([this.getActionsArray()]),
    });
    return f;
  }
  getConditionsArray() {
    let f = this._formBuilder.group({
      condition: [''],
    });
    return f;
  }

  getActionsArray() {
    let f = this._formBuilder.group({
      call_action: ['', [Validators.required]],
    });
    return f;
  }

  getFolloupActions(index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    const callActions = outcomes.controls[index].get('callActions') as FormArray;
    let followupActions = [];
    callActions.controls.forEach(ele => {
      if (ele.value.call_action) {
        followupActions.push(ele.value.call_action);
      }
    })
    return followupActions;
  }


  deleteOutcome(index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.removeAt(index);
  }

  // add more call action
  addMoreActions(outcomeIndex) {
    if (outcomeIndex === undefined || outcomeIndex === null) {
      console.error('Outcome index is undefined or null');
      return;
    }

    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;

    if (!outcomes || outcomes.length <= outcomeIndex) {
      console.error(`Outcomes FormArray is not defined or Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const selectedOutcome = outcomes.at(outcomeIndex);

    if (!selectedOutcome) {
      console.error(`Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const callActions = selectedOutcome.get('callActions') as FormArray;

    if (!callActions) {
      console.error('Conditions FormArray is not defined in the selected outcome');
      return;
    }

    callActions.push(this.getActionsArray());
  }

  // Method to push outcomes into the FormArray
  pushOutcomes(outcomesData: any[]) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;

    outcomesData.forEach((outcome) => {
      outcomes.push(
        this._formBuilder.group({
          outcome_name: [outcome.outcome_name || outcome.name || '', [Validators.required]],
          outcome_appearance: [outcome.outcome_appearance || '', [Validators.required]],
          outcome_description: [outcome.outcome_description || outcome.description || '', [Validators.required]],
          conditions: this._formBuilder.array(
            (outcome.conditions || []).map((condition: any) =>
              this._formBuilder.group({
                condition: [condition.condition || ''],
              })
            ) || [] // Handle missing conditions
          ),
          callActions: this._formBuilder.array(
            (outcome.callActions || []).map((action: any) =>
              this._formBuilder.group({
                call_action: [action.call_action || '', [Validators.required]],
              })
            ) || [] // Handle missing callActions
          ),
        })
      );
    });
  }

  selectAppearance(appearance: any) {

  }
  selectCallAction(callAction: any) {
    console.log(callAction)
  }

  // add more condition
  addMoreConditions(outcomeIndex: number) {
    if (outcomeIndex === undefined || outcomeIndex === null) {
      console.error('Outcome index is undefined or null');
      return;
    }

    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;

    if (!outcomes || outcomes.length <= outcomeIndex) {
      console.error(`Outcomes FormArray is not defined or Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const selectedOutcome = outcomes.at(outcomeIndex);

    if (!selectedOutcome) {
      console.error(`Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const conditions = selectedOutcome.get('conditions') as FormArray;

    if (!conditions) {
      console.error('Conditions FormArray is not defined in the selected outcome');
      return;
    }

    conditions.push(this.getConditionsArray());
  }

  // delete Condition
  deleteCondition(parentIndex, index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    const selectedOutcome = outcomes.at(parentIndex);
    const conditions = selectedOutcome.get('conditions') as FormArray;
    conditions.removeAt(index);
  }

  askQuestion() {

  }

  getAllProjects() {
    this.isLoading = true;
    let sortField = 'created_at';
    const sortOrder = 'desc';
    let searchParams = [];
    this.jobService!.getAllProjects(
      this.profile.entity.id,
      this.projectPageIndex,
      this.projectPageSize,
      sortField,
      sortOrder,
      searchParams
    ).subscribe((res: any) => {
      console.log(res);
      this.isLoading = false;
      if (res && res.items && res.pagination) {
        console.log(res)
        this.projectResultsLength = res.pagination.totalElements;
      }
      console.log(res)
      this.projectsList = res.items;
      this.projectPagination = res.pagination;
    }, (err => {
      this.isLoading = false;
    }));
  }

  addStreamUrlToProject() {
    const projectId = this.projectFormGroup.get('projectId').value;
    const streamUrl = this.projectFormGroup.get('streamUrl').value;

    // Ensure both values are selected before sending the request
    if (!projectId) {
      console.log('Selected project:', projectId);
      alert('Please select a valid project.');
      return;
    }

    if (!streamUrl || !streamUrl.startsWith('rtsp')) {
      console.log('Entered stream URL:', streamUrl);
      alert('Please enter a valid stream URL.');
      return;
    }

    const streamData = {
      stream_id: uuidv4(), // Generate a unique stream ID
      stream_url: streamUrl,
      project_id: projectId
    };

    console.log('Sending stream data:', streamData);

    this.jobService.addStreamUrlToProject(streamData).subscribe(
      (res: any) => {
        console.log('Stream successfully added:', res);
      },
      (err: HttpErrorResponse) => {
        console.error('Error adding stream:', err);
        alert('Failed to add stream. Please check console for details.');
      }
    );
  }
  connectWebsocket() {
    console.log('Form Status:', this.agentThirdForm.status);
    console.log('Form Errors:', this.agentThirdForm.errors);
    console.log('Form Values:', this.agentThirdForm.value);

    const formData = this.agentThirdForm.value;
    console.log('Form Data:', formData);

    this.isConnected = true;
    this.cdRef.detectChanges();
  }


  loadStreamsForProject(projectId: string) {
    this.jobService.getStreamsByProject(projectId).subscribe(
      (streams: any[]) => {
        this.streamsList = streams;
        console.log('Streams loaded:', this.streamsList);
      },
      (err: HttpErrorResponse) => {
        console.error('Error fetching streams:', err);
      }
    );
  }

  addKeywordToStream() {
    if (!this.selectedStreamId || this.selectedStreamId.trim() === '') {
      alert('Please select a stream first.');
      return;
    }

    const outcome = this.agentThirdForm.get('outcomes').value[0];
    console.log("Outcome:", outcome);

    if (!outcome.outcome_name.trim()) {
      alert('Please enter a keyword.');
      return;
    }

    const keywordData = {
      keyword_id: uuidv4(),
      keyword: outcome.outcome_name,
      stream_id: this.selectedStreamId, // ✅ Ensure stream ID is used here
      keyword_description: outcome.outcome_description,
      action_id: uuidv4()
    };

    console.log('Adding keyword:', keywordData);

    this.jobService.addKeywordToStream(keywordData).subscribe(
      (res: any) => {
        console.log('Keyword added:', res);

        // ✅ Refresh the list immediately
        this.fetchKeywordsForStream(this.selectedStreamId);

        // ✅ Reset the form for the next keyword
        this.resetKeywordInput();
      },
      (err: HttpErrorResponse) => {
        console.error('Error adding keyword:', err);
        alert('Failed to add keyword. Please check console for details.');
      }
    );
  }

  // ✅ Reset input fields after adding a keyword
  resetKeywordInput() {
    this.agentThirdForm.patchValue({
      outcomes: [{
        outcome_name: '',
        outcome_description: ''
      }]
    });
  }


  // Listen for stream selection and fetch keywords
  onStreamSelected(streamId: string) {

    if (!streamId) return;

    this.selectedStreamId = streamId;
    console.log('Selected Stream ID:', this.selectedStreamId);
    this.fetchKeywordsForStream(streamId); // ✅ Fetch keywords when stream is selected

    // Find the corresponding RTSP URL from the stream list
    const selectedStream = this.streamsList.find(stream => stream.stream_id === streamId);
    this.selectedStreamUrl = selectedStream ? selectedStream.stream_url : null;

    console.log('Selected Stream URL:', this.selectedStreamUrl);

    if (this.selectedStreamUrl) {
      this.startStream(); // ✅ Call startStream automatically
    }
  }

  // API call to fetch keywords for selected stream
  fetchKeywordsForStream(streamId: string) {
    if (!streamId) return;

    this.jobService.getKeywordsByStream(streamId).subscribe(
      (keywords: any[]) => {
        this.fetchedKeywordsList = keywords;
        console.log('Fetched Keywords:', this.fetchedKeywordsList);
      },
      (err: HttpErrorResponse) => {
        console.error('Error fetching keywords:', err);
        this.fetchedKeywordsList = []; // Reset on error
      }
    );
  }


  //Detection logics
  startDetection() {
    if (!this.selectedStreamId || !this.projectFormGroup.get('projectId').value) {
      alert('Please select a project and stream first.');
      return;
    }

    console.log("Starting detection for stream:", this.selectedStreamId);

    // Show alerts component
    this.isConnected = true;

    // Stop any existing polling
    if (this.detectionInterval) {
      clearInterval(this.detectionInterval);
    }

    // Poll detection API every 5 seconds
    this.detectionInterval = setInterval(() => {
      this.fetchDetectionResults();
    }, 5000);
  }

  stopDetection() {
    if (this.detectionInterval) {
      clearInterval(this.detectionInterval);
      this.detectionInterval = null;
    }
    console.log("Detection stopped.");
  }

  fetchDetectionResults() {
    const projectId = this.projectFormGroup.get('projectId').value;

    if (!this.selectedStreamId || !projectId) {
      console.error("Missing stream ID or project ID.");
      return;
    }

    this.jobService.getDetectionResults(this.selectedStreamId, projectId).subscribe(
      (res: any) => {
        console.log("Detection Results:", res);
        this.detectionResults = res; // ✅ Update local detection data
      },
      (err: HttpErrorResponse) => {
        console.error("Error fetching detection results:", err);
      }
    );
  }

  // detection logics end

}